/**
 * QuotedMessage - o bloco de citação dentro da bolha ("responder em cima"),
 * como no WhatsApp: barra colorida, nome de quem escreveu e a prévia.
 * Clicar rola até a mensagem original (onJump). Compartilhado pelos 3 shells.
 *
 * Props: { quoted: {id, external_id, text, from_me, media_type, sender_name},
 *          contactName, colors, fromMe (da bolha que contém a citação),
 *          onJump(quoted) }
 */
import React from 'react';
import { Image as ImageIcon, Video, Mic, FileText, Sticker } from 'lucide-react';
import { QUOTED_MEDIA_LABEL } from './messageActions';

const MEDIA_ICON = { image: ImageIcon, video: Video, audio: Mic, document: FileText, sticker: Sticker };

const QuotedMessage = ({ quoted, contactName, colors, fromMe = false, onJump }) => {
  if (!quoted) return null;
  const Icon = quoted.media_type ? MEDIA_ICON[quoted.media_type] : null;
  const who = quoted.from_me ? (quoted.sender_name || 'Você') : (contactName || quoted.sender_name || 'Contato');
  const text = quoted.text || (quoted.media_type ? QUOTED_MEDIA_LABEL[quoted.media_type] : 'Mensagem');
  const bar = quoted.from_me ? colors.accentPrimary : '#06cf9c';

  return (
    <div
      role={onJump ? 'button' : undefined}
      onClick={onJump ? (e) => { e.stopPropagation(); onJump(quoted); } : undefined}
      title={onJump ? 'Ir para a mensagem' : undefined}
      style={{
        display: 'flex', gap: 8, alignItems: 'stretch',
        borderRadius: 8, overflow: 'hidden', marginBottom: 6,
        backgroundColor: fromMe ? 'rgba(0,0,0,0.06)' : colors.bgTertiary,
        cursor: onJump ? 'pointer' : 'default', maxWidth: '100%',
      }}
    >
      <div style={{ width: 4, flexShrink: 0, backgroundColor: bar }} />
      <div style={{ padding: '6px 10px 6px 2px', minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: bar, marginBottom: 2 }}>{who}</div>
        <div style={{
          fontSize: 13, color: colors.textSecondary, display: 'flex', alignItems: 'center', gap: 6,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {Icon && <Icon size={14} style={{ flexShrink: 0 }} />}
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</span>
        </div>
      </div>
    </div>
  );
};

export default QuotedMessage;
